import React from 'react';
import LevelUpHeader from '../components/LevelUpHeader';
import LevelUpFooter from '../components/LevelUpFooter';

function TermsOfUse({ user, onLogout }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <LevelUpHeader user={user} onLogout={onLogout} />
      
      <main style={{ flex: 1, backgroundColor: '#F9FAFB', padding: '48px 24px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h1 style={{ 
              fontSize: '36px', 
              fontWeight: '700', 
              color: '#1B5E5F',
              marginBottom: '8px'
            }}>
              ENTERPRISE TERMS OF USE AGREEMENT
            </h1>
            <h2 style={{ 
              fontSize: '24px', 
              fontWeight: '600', 
              color: '#374151',
              marginBottom: '16px'
            }}>
              Why Microsoft – Compete Enablement for Partners
            </h2>
            <p style={{ fontSize: '14px', color: '#6B7280' }}>
              Effective Date: March 2025
            </p>
          </div>

          {/* Content Container */}
          <div style={{ 
            backgroundColor: '#FFFFFF', 
            borderRadius: '12px', 
            padding: '48px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}>
            
            {/* Introduction */}
            <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#374151', marginBottom: '24px' }}>
              These Terms of Use ("Agreement") govern access to and use of the Why Microsoft – Compete Enablement for Partners ("Portal").
            </p>
            
            <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#374151', marginBottom: '24px' }}>
              The Portal and all Content are owned exclusively by Microsoft Corporation ("Microsoft"). The Portal is technically operated and administered by Technofocus PTE LTD ("Technofocus") solely in its capacity as an independent service provider.
            </p>
            
            <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#374151', marginBottom: '32px', fontWeight: '600' }}>
              By accessing or using the Portal, you agree to be legally bound by this Agreement. If you do not agree, you must immediately discontinue use.
            </p>

            {/* Section 1 */}
            <Section number="1" title="Ownership and Intellectual Property">
              <p>All Content, materials, documentation, data, competitive analyses, frameworks, trademarks, service marks, trade dress, branding elements, source materials, derivative works, and proprietary information made available through the Portal are and shall remain the exclusive property of Microsoft or its licensors.</p>
              <p>Nothing in this Agreement transfers, assigns, licenses, or conveys any ownership interest to any User.</p>
              <p>Technofocus has no ownership interest in the Content and claims no intellectual property rights therein.</p>
            </Section>

            {/* Section 2 */}
            <Section number="2" title="Role of Technofocus">
              <p>Technofocus acts strictly as:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li>A hosting provider;</li>
                <li>A technical infrastructure manager;</li>
                <li>An administrative support provider;</li>
                <li>A data processor acting solely on Microsoft's documented instructions.</li>
              </ul>
              <p>Technofocus does not create, modify, validate, endorse, or assume responsibility for Content.</p>
            </Section>

            {/* Section 3 */}
            <Section number="3" title="Absolute Disclaimer of Warranties">
              <p style={{ fontWeight: '600' }}>THE PORTAL AND ALL CONTENT ARE PROVIDED ON AN "AS IS," "AS AVAILABLE," AND "WITH ALL FAULTS" BASIS.</p>
              <p style={{ fontWeight: '600' }}>TO THE MAXIMUM EXTENT PERMITTED BY LAW, MICROSOFT AND TECHNOFOCUS EXPRESSLY DISCLAIM ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li>MERCHANTABILITY;</li>
                <li>FITNESS FOR A PARTICULAR PURPOSE;</li>
                <li>NON-INFRINGEMENT;</li>
                <li>ACCURACY OR COMPLETENESS;</li>
                <li>UNINTERRUPTED OR ERROR-FREE OPERATION;</li>
                <li>SECURITY OR FREEDOM FROM HARMFUL COMPONENTS.</li>
              </ul>
              <p style={{ fontWeight: '600' }}>NO ORAL OR WRITTEN INFORMATION SHALL CREATE ANY WARRANTY.</p>
            </Section>

            {/* Section 4 */}
            <Section number="4" title="Maximum Limitation of Liability">
              <p style={{ fontWeight: '600' }}>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li>NEITHER MICROSOFT NOR TECHNOFOCUS SHALL BE LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR PUNITIVE DAMAGES;</li>
                <li>NEITHER PARTY SHALL BE LIABLE FOR LOSS OF PROFITS, REVENUE, DATA, GOODWILL, BUSINESS INTERRUPTION, OR PROCUREMENT OF SUBSTITUTE SERVICES;</li>
                <li>TECHNOFOCUS SHALL HAVE NO LIABILITY ARISING FROM CONTENT OWNED BY MICROSOFT;</li>
                <li>THE TOTAL AGGREGATE LIABILITY OF TECHNOFOCUS UNDER THIS AGREEMENT SHALL NOT EXCEED ZERO MONETARY LIABILITY, AS ACCESS IS PROVIDED WITHOUT CHARGE;</li>
                <li>ANY LIABILITY OF MICROSOFT SHALL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW.</li>
              </ul>
              <p style={{ fontWeight: '600' }}>THESE LIMITATIONS APPLY REGARDLESS OF LEGAL THEORY AND EVEN IF ADVISED OF THE POSSIBILITY OF DAMAGES.</p>
            </Section>

            {/* Section 5 */}
            <Section number="5" title="User Indemnification">
              <p>You agree to indemnify, defend, and hold harmless Microsoft and Technofocus, including their officers, directors, affiliates, employees, contractors, and agents, from and against any claims, losses, damages, liabilities, penalties, regulatory actions, costs, or expenses (including legal fees) arising from:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li>Your misuse of the Portal;</li>
                <li>Your violation of this Agreement;</li>
                <li>Your unauthorized disclosure or distribution of Content;</li>
                <li>Your violation of applicable laws or third-party rights.</li>
              </ul>
            </Section>

            {/* Section 6 */}
            <Section number="6" title="Data Protection and Privacy">
              <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#1B5E5F', marginBottom: '12px' }}>6.1 Roles and Responsibilities</h4>
              <p>For purposes of applicable data protection laws:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li>Microsoft acts as the Data Controller, determining the purposes and means of processing personal data.</li>
                <li>Technofocus acts solely as a Data Processor, processing personal data strictly on Microsoft's documented instructions.</li>
              </ul>

              <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#1B5E5F', marginBottom: '12px' }}>6.2 Processing Scope</h4>
              <p>Technofocus processes personal data only for the limited purpose of providing hosting, administrative, and technical support services for the Portal.</p>

              <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#1B5E5F', marginBottom: '12px' }}>6.3 No Independent Use</h4>
              <p>Technofocus shall not:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li>Sell, monetize, or commercially exploit personal data;</li>
                <li>Use personal data for its own marketing or business purposes;</li>
                <li>Determine processing purposes independently.</li>
              </ul>

              <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#1B5E5F', marginBottom: '12px' }}>6.4 Security Measures</h4>
              <p>Technofocus shall implement appropriate technical and organizational security measures consistent with industry standards to protect personal data against unauthorized access, disclosure, alteration, or destruction.</p>

              <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#1B5E5F', marginBottom: '12px' }}>6.5 Data Subject Requests</h4>
              <p>All data subject rights requests shall be directed to Microsoft as Data Controller. Technofocus shall provide reasonable assistance to Microsoft in responding to such requests.</p>
            </Section>

            {/* Section 7 */}
            <Section number="7" title="Confidentiality">
              <p>All non-public Content is confidential and proprietary to Microsoft. Users shall maintain strict confidentiality and shall not disclose such Content without prior written authorization.</p>
            </Section>

            {/* Section 8 */}
            <Section number="8" title="Force Majeure">
              <p>Neither Microsoft nor Technofocus shall be liable for any delay or failure resulting from causes beyond reasonable control, including acts of God, governmental actions, cyber incidents, infrastructure failures, or force majeure events.</p>
            </Section>

            {/* Section 9 */}
            <Section number="9" title="Modifications and Termination">
              <p>Microsoft reserves the unilateral right to modify, suspend, restrict, or terminate access to the Portal at any time without liability.</p>
              <p>Continued use following updates constitutes binding acceptance.</p>
            </Section>

            {/* Section 10 */}
            <Section number="10" title="Governing Law and Exclusive Jurisdiction">
              <p>This Agreement shall be governed by the laws of Singapore, without regard to conflict of law principles.</p>
              <p>Any dispute shall be resolved exclusively in the courts of Singapore.</p>
            </Section>

            {/* Section 11 */}
            <Section number="11" title="No Third-Party Beneficiaries">
              <p>Nothing in this Agreement creates any partnership, joint venture, agency, or fiduciary relationship. No third party shall have enforcement rights under this Agreement.</p>
            </Section>

            {/* Section 12 */}
            <Section number="12" title="Entire Agreement">
              <p>This Agreement constitutes the complete and exclusive understanding regarding use of the Portal.</p>
            </Section>

          </div>
        </div>
      </main>

      <LevelUpFooter />
    </div>
  );
}

// Reusable Section Component
function Section({ number, title, children }) {
  return (
    <div style={{ marginBottom: '32px' }}>
      <h3 style={{ 
        fontSize: '20px', 
        fontWeight: '600', 
        color: '#1B5E5F',
        marginBottom: '16px',
        paddingBottom: '8px',
        borderBottom: '2px solid #E5E7EB'
      }}>
        {number}. {title}
      </h3>
      <div style={{ 
        fontSize: '15px', 
        lineHeight: '1.8', 
        color: '#374151'
      }}>
        {React.Children.map(children, child => {
          if (child.type === 'p') {
            return React.cloneElement(child, {
              style: { ...child.props.style, marginBottom: '16px' }
            });
          }
          return child;
        })}
      </div>
    </div>
  );
}

export default TermsOfUse;
